import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {SelectFieldsTable} from '../../../shared/select-fields.table';
import {SelectLocationTable} from '../../../../shared/location-select.table';
import {SalaryComparatorService} from './_services/salaryComparator.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SalaryComparatorModel} from './_models/salary-comparator.model';

@Component({
    selector: 'app-salary-comparator',
    templateUrl: './salary-comparator.component.html',
    styleUrls: ['./salary-comparator.component.scss'],
    providers: [SelectFieldsTable, SelectLocationTable]
})
export class SalaryComparatorComponent implements OnInit {

    constructor(public selectFields: SelectFieldsTable,
                private locationSelect: SelectLocationTable,
                private salaryService: SalaryComparatorService,
                private modalService: NgbModal) {
    }

    // Error Messages
    messageResponse: boolean;
    formSent: boolean;

    // Location - Country & City
    location = this.locationSelect.Countries;
    cities = [];

    // Domains & Subdomains
    allDomains = this.selectFields.domains
    subdomains = []

    // Salary Calculator
    compareRequestSend: boolean;
    compareInfo: boolean;
    compareMessage: string;
    compareFormData: SalaryComparatorModel;


    ngOnInit() {
    }

    sendSalaryCompare(form: NgForm) {
        this.compareInfo = false;
        this.formSent = false;
        const formData = form.value;
        if (form.valid) {
            this.salaryService.createSalaryComparator(formData).subscribe((data: any) => {
                    const resultId = data.reason;
                    this.compareRequestSend = true;
                    this.salaryService.compareSalary(resultId).subscribe((resp: any) => {
                        this.compareInfo = true;
                        if (resp.reason === 'salaryBiggerThanAverage') {
                            this.compareMessage = 'La momentul actual salariul tău este peste medie'
                        } else if (resp.reason === 'salaryLowerThanAverage') {
                            this.compareMessage = 'La momentul actual salariul tău este sub medie'
                        } else if (resp.reason === 'salaryEqualAverage') {
                            this.compareMessage = 'La momentul actual salariul tău este egal cu media salariilor din acest domeniu.'
                        } else if (resp.reason === 'noValuePresent'){
                            this.compareMessage = 'Nu exista suficiente date in aceasta categorie.'
                        }
                    }, error => {
                        this.compareInfo = false;
                    })

                    this.salaryService.compareSalaryById(resultId).subscribe((res: any) => {
                        this.compareFormData = res;
                    })
                },
                error => {
                    this.messageResponse = false;
                    this.formSent = true;
                }
            )
        } else {
            this.messageResponse = false;
            this.formSent = true;
        }

    }

    choseCity(event) {
        this.cities = this.location.find((country: any) => country.name === event.target.value).cities;
    }

    choseSubdomains(event) {
        this.subdomains = this.allDomains.find((domain: any) => domain.name === event.target.value).subdomains;
    }

}
